import { render, staticRenderFns } from "./InitializeAccount.vue?vue&type=template&id=c4e1ddda&scoped=true"
import script from "./InitializeAccount.vue?vue&type=script&lang=js"
export * from "./InitializeAccount.vue?vue&type=script&lang=js"
import style0 from "./InitializeAccount.vue?vue&type=style&index=0&id=c4e1ddda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e1ddda",
  null
  
)

export default component.exports